import React from "react";
import { Link } from "react-router-dom";
import styles from "./NotFoundPage.module.scss";
import useNotFoundPage from "./useNotFoundPage";

export default function NotFoundPage() {
    const { handlers, utilities } = useNotFoundPage();
    const { t, homePath } = utilities;

    return (
        <div className={styles.page}>
            <div className={styles.content}>
                <div className={styles.illustration} aria-hidden="true">
                    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="52" cy="52" r="34" stroke="#E5E5E5" strokeWidth="9" fill="none"/>
                        <line x1="78" y1="78" x2="104" y2="104" stroke="#E5E5E5" strokeWidth="10" strokeLinecap="round"/>
                        <circle cx="52" cy="68" r="3.5" fill="#99A39F"/>
                        <path d="M52 59 C52 55, 59 52, 59 46 C59 40, 45 40, 45 46" stroke="#99A39F" strokeWidth="5" strokeLinecap="round" fill="none"/>
                    </svg>
                </div>

                <h1 className={styles.title}>{t("ERROR_404Title")}</h1>
                <p className={styles.message}>{t("ERROR_404Message")}</p>

                <div className={styles.actions}>
                    <Link to={homePath} className="btn btn-primary">
                        {t("ERROR_404Home")}
                    </Link>
                    <button className="btn btn-outline-secondary" onClick={handlers.handleGoBack}>
                        {t("ERROR_404Back")}
                    </button>
                </div>
            </div>
        </div>
    );
}
